import dayjs from '@/lib/dayjs'
import type { ConfigType, Dayjs } from 'dayjs'

/** Whole calendar days from a date to now in the organization timezone, never negative. */
export function calendarDaysSince(value: ConfigType, now: Dayjs = dayjs()): number {
  return Math.max(0, now.startOf('day').diff(dayjs(value).startOf('day'), 'day'))
}
